parseTokensYYY